import React, { Fragment, useEffect, useState } from "react";
import { cn } from "@/libs/utils";
import { Emitter } from "src/utils/Emitter";

export enum Severity {
  error = "error",
  info = "info",
  //   warning = "warning",
  // success = "success",
}

const emitter = new Emitter();

export default function Toast() {
  const [message, setMessage] = useState<string>("");
  const [severity, setSeverity] = useState<Severity>(Severity.info);

  useEffect(() => {
    const sub = emitter.subscribe(Severity.info, (message: any) => {
      setMessage(message);
      setSeverity(Severity.info);
    });
    return () => {
      sub.unsubscribe();
    };
  }, []);

  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => setMessage(""), 2000);
      return () => clearTimeout(timer);
    }
  }, [message]);

  if (!message) return null;

  return (
    <div className="fixed right-4 top-4 z-[1400]">
      <div
        className={cn(
          "flex items-center gap-2 rounded px-4 py-3 shadow-lg",
          severity === Severity.error
            ? "bg-red-50 text-red-800"
            : "bg-blue-50 text-blue-800",
        )}
      >
        <span className="flex-1">{message}</span>
        <button
          onClick={() => setMessage("")}
          className="ml-2 text-current opacity-70 hover:opacity-100"
        >
          <svg
            className="h-4 w-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>
    </div>
  );
}
